// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2FgaX","title":"Images90_title__Z0zid","images":"Images90_images__il5o2"};